<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_2"></a><a id="Copyright">Published in 2005 by<br/>
Grub Street<br/>
4 Rainham Close<br/>
London<br/>
SW11 6SS<br/>
Email: </a><a href="mailto:food@grubstreet.co.uk">food@grubstreet.co.uk</a><br/>
Web: <a href="http://www.grubstreet.co.uk" target="_blank">www.grubstreet.co.uk</a></p>
<p class="copyright3">Text copyright © Marguerite Patten 2005<br/>
Copyright this edition © Grub Street 2005<br/>
Design Lizzie Ballantyne</p>
<p class="copyright3">The right of Marguerite Patten to be identified as the author of this work has been asserted by her in<br/>
accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copyright3">Originally published in 1989 as The Complete Book of Teas by Piatkus Books</p>
<p class="copyright3">British Library Cataloguing in Publication Data</p>
<p class="copyright3">Patten, Marguerite<br/>
Marguerite Patten’s 100 top teatime treats<br/>
1.Cake 2. Pastry 3. Afternoon teas<br/>
I. Title II 100 top teatime treats<br/>
641.8’65</p>
<p class="copyright3">ISBN-10 : 1 904943 29 2<br/>
PRINT ISBN: 978 1 904943 29 7<br/>
EPUB ISBN: 978 1 909808 70 6</p>
<p class="copyright3">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means,<br/>
electronic or mechanical, including photocopying, recording or any information storage and retrieval<br/>
system, without permission in writing from the publisher.</p>
<p class="copyright3">Printed and bound in Spain</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?81454c50